export default __webpack_public_path__ + "static/media/Self-Resurrection Potion.ac9d94ec.jpg";